import { Box, Typography } from "@mui/material";
import NavBackButton from "../../../../components/NavBackButton";

export default function MobileHeader() {
  return (
    <Box
      sx={{
        width: "100%",
        zIndex: 10,
        transition: "box-shadow 500ms",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        paddingY: "12px",
        paddingX: "8px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <NavBackButton />
        <Typography
          sx={{
            fontWeight: "600",
            color: "secondary.main",
          }}
        >
          اعلان‌ها
        </Typography>
      </Box>

      {/* <CustomButton
        onClick={() => navigate("../settings")}
        flexDirection="row"
        title="تنظیمات اطلاع‌رسانی"
        justifyContent="center"
        rippleColor={theme.palette.secondary.main}
        bgColor={theme.palette.secondary[50]}
        textColor="secondary.main"
        fSize="14px"
        borderColor="secondary.main"
        fWeight="700"
        px="10px"
        py="10px"
        borderRadius="10px"
        icon1={<SettingsIcon color={theme.palette.secondary.main} />}
      /> */}
    </Box>
  );
}
